import { TableFilter } from "@neonumy/ant-design";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useAccountingApi from "views/Settings/Accounting/hooks/useAccountingApi";
import useColumnsTable from "../hooks/useColumnsTable";
import useExportApi from "../hooks/useExportApi";

interface ExportedTableProps {
  refetchRef?: React.MutableRefObject<(() => void) | undefined>;
}

export default function ExportedTable({ refetchRef }: ExportedTableProps): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const urlParams: RouteParams = useParams();

  const {
    listCompanyExportsLoading: loading,
    listExportsData: dataSource,
    refetchListCompanyExports: refetch,
    listCompanyExports,
  } = useAccountingApi();
  const { columns } = useColumnsTable(refetch);
  const { url } = useExportApi(refetch);

  useEffect(() => {
    if (refetchRef) {
      refetchRef.current = refetch;
    }
  }, [refetch]);

  useEffect(() => {
    listCompanyExports({
      variables: {
        filter: { companyId: urlParams.companyId, bookEntriesSource: "nf" },
      },
    });
  }, []);

  useEffect(() => {
    if (url) {
      const link = document.createElement("button");
      link.onclick = () => window.open(`${url}&download=1`, "_blank");
      link.click();
    }
  }, [url]);

  return (
    <TableFilter
      className="antd-newrai-table"
      size="small"
      scroll={{ y: windowHeight - 650 }}
      dataSource={dataSource}
      loading={loading}
      columns={columns}
    />
  );
}
